import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./styles/app.sass";
import Page from "./components/Page";
import ProfileEdit from "./screens/ProfileEdit";
import NHome from "./screens/NHome";
import NAccount from "./screens/NAccount";
import Chat from "./screens/Chat";
import Game from "./screens/Game";
import ConquerContextProvider from "./contexts/ConquerContext";
import UserContextProvider from "./contexts/UserContext";
import ModalContextProvider from "./contexts/Modal/ModalContext";
import Friends from "./screens/Friends";
import PageContent from "./components/PageContent";
import SearchContextProvider from "./contexts/SearchContext";
import GameContextProvider from "./contexts/GamesContext";

function App() {

    const renderRoute = function( {path, content, needsLogin = false} ){
        return <Route exact key={path} path={path} render={({}) => <PageContent needsLogin={needsLogin}>{content}</PageContent>}/>
    };

  return (
    <ConquerContextProvider>
    <UserContextProvider>
    <ModalContextProvider>
    <SearchContextProvider>
      <Router>
        <GameContextProvider>
            <Page>
                <Switch>
                    {renderRoute({path: '/',content: <NHome/>, needsLogin: false})}
                    {renderRoute({path: '/profile',content: <ProfileEdit/>, needsLogin: true})}
                    {/* {renderRoute({path: '/profile-edit',content: <ProfileEdit/>, needsLogin: true})} */}
                    {renderRoute({path: '/friends',content: <Friends/>, needsLogin: true})}
                    {renderRoute({path: '/chat/:friendID?',content: <></>, needsLogin: true})}
                    {renderRoute({path: '/game/:gameKey?',content: <Game/>, needsLogin: false})}
                </Switch>
            </Page>
        </GameContextProvider>
      </Router>
    </SearchContextProvider>
    </ModalContextProvider>
    </UserContextProvider>
    </ConquerContextProvider>
  );
}

export default App;
